<div class="container-fluid">
  <div class="row mb-2">
    <h3>CISA - Arquivos</h3>
    <span class="spacer"></span>
    <button mat-raised-button (click)="enviarArquivos()">
      Enviar Arquivos
    </button>
    <button
      mat-raised-button
      (click)="receberArquivos()"
      class="receberArquivos"
    >
      Receber processados
    </button>
  </div>

  <form #thisForm="ngForm" class="filter">
    <mat-card>
      <mat-card-header> </mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="PeriodoDe"
                [matDatepicker]="picker"
                placeholder="Período de"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoAte"
                [(ngModel)]="PeriodoAte"
                [matDatepicker]="picker2"
                placeholder="Até"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6">
            <ng-select
              bindLabel="description"
              bindValue="id"
              name="statusId"
              notFoundText="Nenhum status encontrado"
              placeholder="Status"
              [(ngModel)]="StatusFilter"
              (change)="getReceivables()"
            >
              <ng-option *ngFor="let status of Statuses" [value]="status.id">{{
                status.description
              }}</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Arquivo"
                [(ngModel)]="Arquivo"
                name="arquivo"
              />
            </mat-form-field>
          </div>
          <div class="col-3">
            <ng-select
              bindLabel="name"
              bindValue="id"
              name="fundId"
              notFoundText="Nenhum fundo encontrado"
              placeholder="Fundo"
              [(ngModel)]="FundFilter"
              (change)="getReceivables()"
              class="fundo"
            >
              <ng-option *ngFor="let fund of Funds" [value]="fund.id">{{
                fund.name
              }}</ng-option>
            </ng-select>
          </div>
          <div class="spacer"></div>
          <div class="col-1">
            <button mat-raised-button type="button" (click)="clear()">
              Limpar
            </button>
          </div>
          <div class="col-1">
            <button mat-raised-button type="submit" (click)="getReceivables()">
              Buscar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>

  <div class="row mb-2">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef>Nome do arquivo</th>
        <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
      </ng-container>

      <ng-container matColumnDef="processingDate">
        <th mat-header-cell *matHeaderCellDef>Data Processamento</th>
        <td mat-cell *matCellDef="let element">
          {{ element.processingDate | date: "dd/MM/yyyy HH:mm:ss" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="operationCount">
        <th mat-header-cell *matHeaderCellDef>Número operações</th>
        <td mat-cell *matCellDef="let element">{{ element.operationCount }}</td>
      </ng-container>

      <ng-container matColumnDef="fundName">
        <th mat-header-cell *matHeaderCellDef>Nome Fundo</th>
        <td mat-cell *matCellDef="let element">{{ element.fundName }}</td>
      </ng-container>

      <ng-container matColumnDef="sequenceNumber">
        <th mat-header-cell *matHeaderCellDef>Sequencial</th>
        <td mat-cell *matCellDef="let element">{{ element.sequenceNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.history != null &&
            element.history[element.history.length - 1] != null
              ? element.history[element.history.length - 1].status.description
              : ""
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let detail" colspan="6" style="padding: 0">
          <div
            class="row mb-2 detail"
            *ngFor="let detailElement of detail.history"
          >
            <div class="column">
              {{ detailElement.date | date: "dd/MM/yyyy HH:mm:ss" }}
            </div>
            <div class="column">
              {{ detailElement.status.description }}
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        matRipple
        [class.expanded]="expandedElement == row.id"
        (click)="expandedElement = row.id"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
      <tr
        mat-row
        matRipple
        [class.expanded]="expandedElement == row.id"
        *matRowDef="
          let row;
          columns: ['expandedDetail'];
          when: isExpansionDetailRow
        "
        [@detailExpand]="row.id == expandedElement ? 'expanded' : 'collapsed'"
      ></tr>
    </table>
  </div>

  <br />

  <paginador
    [listedPages]="listedPages"
    [firstItemOnPage]="firstItemOnPage"
    [lastItemOnPage]="lastItemOnPage"
    [totalPages]="totalPages"
    [totalItems]="totalItems"
    [currentPage]="currentPage"
    [itemsPerPage]="[10, 25, 50, 100, 200]"
    (onSearch)="getReceivables($event[0], $event[1])"
  ></paginador>
</div>
